import React from "react"
import {useTranslation} from "react-i18next"

import {ApiForm, FormSection, Field, TitleSection} from "~/components/"

import {Destination} from "~/utils/ShelfEntities"

const NewDestinationView = ({match}) => {
  const {t} = useTranslation()
  return (
    <ApiForm
      for={Destination}
      id={match.params.destination_id}
      then="/destinations"
      submitLabel={t("destinations.detail.submit")}
    >
      <TitleSection>
        <h3>
          {match.params.destination_id
            ? t("destinations.detail.titleEdit")
            : t("destinations.detail.titleNew")}
        </h3>
      </TitleSection>
      <FormSection label={t("destinations.detail.basic")}>
        <Field label={t("destinations.detail.name")} type="Text" name="name" />
      </FormSection>
    </ApiForm>
  )
}

export default NewDestinationView



// WEBPACK FOOTER //
// ./src/views/NewDestinationView.js